<ng-container *ngIf="!isSmbsFlow">
  <invd-enter-balances-recombinations-table-row
    *ngFor="
      let recombinationGroup of recombinationGroups;
      let idx = index;
      trackBy: trackByIdentity
    "
    [recombinationTableGroup]="recombinationGroup"
    [tableIndex]="idx"
    [recombinationTableRowExchangeType]="recombinationTableExchangeTypeFinal"
    [isExternalUser]="isExternalUser"
    [isFromTakedownPage]="isFromTakedownPage"
    (startedEditing)="onRowStartedEditing()"
  >
  </invd-enter-balances-recombinations-table-row>
</ng-container>

<ng-container *ngIf="isSmbsFlow">
  <invd-smbs-exchange-table
    *ngFor="
      let recombinationGroup of recombinationGroups;
      let idx = index;
      trackBy: trackByIdentity
    "
    [smbsRecombinationExchanges]="recombinationGroup"
    [clearBtnClick]="isSmbsClearBtnClick"
    class="smbs-exchange-table"
  >
  </invd-smbs-exchange-table>
</ng-container>
